import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import Page from '@/components/Page'
import { getCurrentOrganization, isRequestPending } from '@/store/selectors'

import AccountManagementConnector from './AccountManagementConnector'
import {
  addAccountManagementConnector,
  clearClientSecret,
  clearPrivateKey,
  deleteAccountManagementConnector,
  deleteScimTokenKey,
  getAccountManagementConnector,
  getScimTokenKey
} from './actions'
import {
  ADD_ACCOUNT_MANAGEMENT_CONNECTOR,
  DELETE_SCIM_TOKEN_KEY,
  GET_ACCOUNT_MANAGEMENT_CONNECTOR,
  GET_SCIM_TOKEN_KEY,
  REMOVE_ACCOUNT_MANAGEMENT_CONNECTOR
} from './actionTypes'
import messages from './messages'
import { getApiHost, getScimToken, getUserManagementConnectors } from './selectors'

function OrganizationUserProvisioningPage(props: any) {
  const history = useHistory()
  const location = useLocation()

  // componentDidMount
  useEffect(() => {
    props.actions.getScimTokenKey()
    props.actions.getAccountManagementConnector()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // componentWillUnmount
  useEffect(() => {
    return () => {
      props.accountManagementConnectors[0] && props.actions.clearClientSecret(props.accountManagementConnectors[0].id)

      props.scimToken && props.actions.clearPrivateKey(props.scimToken.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const createAccountManagementConnector = () => {
    props.actions.addAccountManagementConnector()
  }

  const deleteAccountManagementConnector = (accountManagementConnectorId: any, scimTokenId: any) => {
    if (accountManagementConnectorId) {
      props.actions.deleteAccountManagementConnector(accountManagementConnectorId)
    }

    if (scimTokenId) {
      props.actions.deleteScimTokenKey(scimTokenId)
    }
  }

  const goBack = () => {
    history.push(location.pathname.slice(0, Math.max(0, location.pathname.lastIndexOf('/'))))
  }

  const {
    accountManagementConnectors,
    apiHost,
    isAccountManagementLoading,
    isScimAddInProgress,
    isScimDeleteInProgress,
    organization,
    scimToken
  } = props
  return (
    <Page className="orgainzation-users-wrapper" isLoading={isAccountManagementLoading}>
      <Page.Header
        title={<FormattedMessage {...messages.pageTitle} />}
        goBack={goBack}
        backNavTitle={<FormattedMessage {...messages.back} />}
      />
      <div className="account-management">
        <AccountManagementConnector
          apiHost={apiHost}
          isScimAddInProgress={isScimAddInProgress}
          isScimDeleteInProgress={isScimDeleteInProgress}
          onCreate={createAccountManagementConnector}
          onDelete={deleteAccountManagementConnector}
          accountManagementConnector={accountManagementConnectors[0]}
          organizationId={organization.id}
          scimToken={scimToken}
        />
      </div>
    </Page>
  )
}

OrganizationUserProvisioningPage.displayName = 'OrganizationUserProvisioningPage'

OrganizationUserProvisioningPage.propTypes = {
  actions: PropTypes.shape({
    addAccountManagementConnector: PropTypes.func.isRequired,
    clearClientSecret: PropTypes.func.isRequired,
    clearPrivateKey: PropTypes.func.isRequired,
    deleteAccountManagementConnector: PropTypes.func.isRequired,
    deleteScimTokenKey: PropTypes.func.isRequired,
    getAccountManagementConnector: PropTypes.func.isRequired,
    getScimTokenKey: PropTypes.func.isRequired
  }).isRequired,
  accountManagementConnectors: PropTypes.arrayOf(
    PropTypes.shape({
      clientCredential: PropTypes.shape({
        clientId: PropTypes.string,
        clientSecret: PropTypes.string
      }),
      id: PropTypes.string,
      type: PropTypes.string
    })
  ),
  apiHost: PropTypes.string.isRequired,
  isAccountManagementLoading: PropTypes.bool.isRequired,
  isScimAddInProgress: PropTypes.bool.isRequired,
  isScimDeleteInProgress: PropTypes.bool.isRequired,
  organization: PropTypes.object.isRequired,
  scimToken: PropTypes.shape({
    id: PropTypes.string,
    issuer: PropTypes.string,
    scimToken: PropTypes.string
  })
}

OrganizationUserProvisioningPage.defaultProps = {
  accountManagementConnectors: [],
  organization: {},
  scimToken: null
}

export { OrganizationUserProvisioningPage }

function mapStateToProps(state: any) {
  return {
    accountManagementConnectors: getUserManagementConnectors(state),
    apiHost: getApiHost(state),
    isAccountManagementLoading: isRequestPending(state, [GET_ACCOUNT_MANAGEMENT_CONNECTOR, GET_SCIM_TOKEN_KEY]),
    isScimAddInProgress: isRequestPending(state, ADD_ACCOUNT_MANAGEMENT_CONNECTOR),
    isScimDeleteInProgress: isRequestPending(state, [REMOVE_ACCOUNT_MANAGEMENT_CONNECTOR, DELETE_SCIM_TOKEN_KEY]),
    scimToken: getScimToken(state),
    organization: getCurrentOrganization(state)
  }
}

function mapDispatchToProps(dispatch: any) {
  return {
    actions: bindActionCreators(
      {
        addAccountManagementConnector,
        deleteAccountManagementConnector,
        deleteScimTokenKey,
        getAccountManagementConnector,
        getScimTokenKey,
        clearClientSecret,
        clearPrivateKey
      },
      dispatch
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(OrganizationUserProvisioningPage)
